import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { StartupService } from '@core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'customMessage',
  templateUrl: './custom-messages.html',
  styleUrls: ['./custom-messages.scss'],
})
export class CustomMessages implements OnInit {
  msg: string;

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private startupService: StartupService
  ) { }

  ngOnInit() { }

  showErrorMessage(messageId, message) {
    if (message == 'UNAUTHORIZED') {
      messageId = 'cams.label.customMessage.kindlyLoginInApplication';
      message = '';
    }

    this.msg = this.startupService.data[messageId];

    if (message != '') this.msg = this.msg + ' : ' + message;

    this.snackBar.open(this.msg, 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['error-info'],
    });

    if (messageId == 'cams.label.customMessage.kindlyLoginInApplication') {
      this.router.navigate(['/login']);
    }
  }

  showErrorValueBeforeKeyMessage(message, messageId) {
    if (message == 'UNAUTHORIZED') {
      messageId = 'cams.label.customMessage.kindlyLoginInApplication';
      message = '';
    }

    this.msg = this.startupService.data[messageId];

    if (message != '') this.msg = message + ' ' + this.msg;

    this.snackBar.open(this.msg, 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['error-info'],
    });

    if (messageId == 'cams.label.customMessage.kindlyLoginInApplication') {
      this.router.navigate(['/login']);
    }
  }

  showErrorValueBeforeAndAfterKeyMessage(messageId1, message, messageId2) {
    if (message == 'UNAUTHORIZED') {
      messageId1 = 'cams.label.customMessage.kindlyLoginInApplication';
      message = '';
    }

    if (message != '')
      this.msg =
        this.startupService.data[messageId1] + ' ' + message + this.startupService.data[messageId2];

    this.snackBar.open(this.msg, 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['error-info'],
    });

    if (messageId1 == 'cams.label.customMessage.kindlyLoginInApplication') {
      this.router.navigate(['/login']);
    }
  }

  //  this.snackBar.open(message, 'Close', { duration: 3500, verticalPosition: 'top', panelClass: 'snack-error'});
  showSuccessMessage(messageId) {

    this.msg = this.startupService.data[messageId];
    this.snackBar.open(this.msg, 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['sucessfully-info'],
    });
  }

  showSuccessMessageUpload(successCount, successMessage, errorCount, errorMessage) {

    var successMsg = this.startupService.data[successMessage];
    var errorMsg = this.startupService.data[errorMessage];
    this.msg = successCount + " " + successMsg + " " + errorCount + " " + errorMsg;
    this.snackBar.open(this.msg, 'Close', {
      duration: 6000,
      verticalPosition: 'top',
      panelClass: ['sucessfully-info'],
    });
  }

  showSuccessMessageFromDB(messageId) {
    this.msg = messageId;
    this.snackBar.open(this.msg, 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['sucessfully-info'],
    });
  }

  returnMessage(messageId) {
    return (this.msg = this.startupService.data[messageId]);
  }
}
